/* Icon shortcuts enhance native details; instructions remain usable without JS. */
class RedLightRoutineSteps extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const panels = [...this.querySelectorAll('[data-rl-step-panel]')];
    const buttons = [...this.querySelectorAll('[data-rl-step]')];
    const sync = () => {
      for (const button of buttons) {
        const panel = panels.find((item) => item.id === button.dataset.rlStep);
        button.setAttribute('aria-expanded', String(Boolean(panel?.open)));
      }
    };
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-rl-step]');
      if (!button || !this.contains(button)) return;
      const panel = panels.find((item) => item.id === button.dataset.rlStep);
      if (!panel) return;
      for (const item of panels) item.open = item === panel;
      panel.querySelector('summary').focus({ preventScroll: true });
      sync();
    }, { signal });
    this.addEventListener('toggle', (event) => {
      if (!panels.includes(event.target)) return;
      if (event.target.open) {
        for (const panel of panels) {
          if (panel !== event.target) panel.open = false;
        }
      }
      sync();
    }, { capture: true, signal });
    sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('rl-routine-steps')) {
  customElements.define('rl-routine-steps', RedLightRoutineSteps);
}
